module.exports = "mutation ($id: ID!) {\n  IntegrationDelete(id: $id) {\n    id\n  }\n}\n"